export const NEWS_LETTER_OPEN_DELAY = 10000
